import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Button, Modal, Form } from 'semantic-ui-react'
import Proptypes from 'prop-types'
import { useSelector } from 'react-redux'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import Swal from 'sweetalert2'
import moment from 'moment'
import styles from '../../device/device-info-view/device-view.module.css'
import IntelMsg from '../../../ItelMsg'
import {
  GetAllDeviceInfo,
  SubmitAllDeviceInfo,
} from '../../../../services/device-page-list'
// import { getHierarchy } from '../../../../services/customer'

// eslint-disable-next-line no-unused-vars
let product = ''
const regex = /^([+]|00)[0-9]{3,}$/g
const formValidator = {
  simNumber: yup
    .string()
    .nullable()
    .notRequired()
    .transform((value) => (value === '' ? null : value))
    .matches(regex, 'Number must starts with + or 00 and NOT exceed 11 digits'),
  imsi: yup
    .string()
    .nullable()
    .notRequired()
    .transform((value) => (value === '' ? null : value))
    .min(6, 'Too Short'),
  warranty: yup
    .string()
    .nullable()
    .notRequired()
    .transform((value) => (value === '' ? null : value)),
  deliveryDate: yup
    .date()
    .nullable()
    .notRequired()
    .transform((value, originalValue) => (originalValue === '' ? null : value)),
  siteName: yup
    .string()
    .nullable()
    .notRequired()
    .transform((value) => (value === '' ? null : value)),
  deviceModel: yup
    .string()
    .nullable()
    .notRequired()
    .transform((value) => (value === '' ? null : value)),
  name: yup
    .string()
    .nullable()
    .notRequired()
    .transform((value) => (value === '' ? null : value)),
  // siteId: yup.string().trim().required('Please Select a Site'),
}

// eslint-disable-next-line no-unused-vars
const EditModal = ({ open, setOpenEditModal, prop, assetData }) => {
  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  if (userEmail) {
    product = localStorage.getItem('product')
  }
  const { register, handleSubmit, errors, setValue } = useForm({
    resolver: yupResolver(yup.object().shape(formValidator)),
  })

  // const [sites, setSites] = useState([])

  const [body, setBody] = useState({
    length: '',
    type: '',
    latitude: '',
    imei: '',
    longitude: '',
    siteId: '',
    siteName: null,
    height: '',
    imsi: null,
    picture: '',
    diameter: '',
    simNumber: null,
    width: '',
    volume: '',
    raiser: '',
    deviceModel: null,
    deviceLabel: null,
    warranty: null,
    deliveryDate: null,
  })

  const { deviceData } = useSelector((store) => ({
    deviceData: store.deviceData.deviceData,
  }))

  useEffect(() => {
    GetAllDeviceInfo(deviceData['device id']).then((data) => {
      setBody(data)
    })
  }, [deviceData])

  useEffect(() => {
    ;(async () => {
      if (open) {
        setValue('simNumber', body.simNumber)
        setValue('imsi', body.imsi)
        setValue('deviceModel', body.deviceModel)
        setValue('siteName', body.siteName)
        setValue('name', body.deviceLabel)
        setValue('warranty', body.warranty)
        setValue('deliveryDate', body.deliveryDate)
      }
    })()
  }, [open])

  const handleEdit = (_data) => {
    console.log('_dataaa: ', _data)
    const editModalBody = {
      ...body,
      simNumber: _data.simNumber || null,
      imsi: _data.imsi || null,
      deviceModel: _data.deviceModel || null,
      siteName: _data.siteName || null,
      name: _data.name || null,
      warranty: _data.warranty || null,
      deliveryDate: moment(_data.deliveryDate).format('YYYY-MM-DD') || null,
      // deliveryDate: new Date(_data.deliveryDate).toLocaleDateString(),
      // siteId: _data.siteId.split(',')[0],
      // siteName: _data.siteId.split(',')[1],
    }
    console.log('body: ', editModalBody)
    Swal.showLoading()
    SubmitAllDeviceInfo({
      deviceId: deviceData['device id'],
      ...editModalBody,
    }).then(async (data) => {
      Swal.close()
      console.log('submitted data :  ', data)
      if (data === 200) {
        setOpenEditModal(false)
        await Swal.fire({
          title: 'Device Updated Successfully!',
          confirmButtonColor: 'Green',
          icon: 'success',
        })
        prop()
      }
    })
  }
  return (
    <>
      <Modal
        size="small"
        open={open}
        style={{ position: 'relative', height: 'auto' }}
      >
        <Modal.Header className={styles.header}>Edit Device</Modal.Header>
        <Modal.Content scrolling>
          <Form
            id="deviceAddForm"
            widths="equal"
            onSubmit={handleSubmit(handleEdit)}
          >
            <Form.Field>
              <span style={{ color: 'black' }}>SIM Number</span>
              <input
                name="simNumber"
                ref={register}
                type="tel"
                placeholder="Sim Number"
              />
              <br />
              {errors.simNumber && (
                <p style={{ color: 'red' }}>{errors.simNumber.message}</p>
              )}
            </Form.Field>
            <Form.Field>
              <span style={{ color: 'black' }}>IMSI</span>
              <input name="imsi" ref={register} placeholder="Imsi" />
              <br />
              {errors.imsi && (
                <p style={{ color: 'red' }}>{errors.imsi.message}</p>
              )}
            </Form.Field>
            <Form.Field>
              <span style={{ color: 'black' }}>Device Model</span>
              <input
                name="deviceModel"
                ref={register}
                placeholder="Device Model"
              />
              <br />
              {errors.deviceModel && (
                <p style={{ color: 'red' }}>{errors.deviceModel.message}</p>
              )}
            </Form.Field>
            <Form.Field>
              <span style={{ color: 'black' }}>Site Name</span>
              <input name="siteName" ref={register} placeholder="Site Name" />
              <br />
              {errors.siteName && (
                <p style={{ color: 'red' }}>{errors.siteName.message}</p>
              )}
            </Form.Field>
            <Form.Field>
              <span style={{ color: 'black' }}>Device Label</span>
              <input name="name" ref={register} placeholder="Device Label" />
              <br />
              {errors.name && (
                <p style={{ color: 'red' }}>{errors.name.message}</p>
              )}
            </Form.Field>
            <Form.Field>
              <span style={{ color: 'black' }}>Warranty</span>
              <input name="warranty" ref={register} placeholder="Warranty" />
              <br />
              {errors.warranty && (
                <p style={{ color: 'red' }}>{errors.warranty.message}</p>
              )}
            </Form.Field>
            <Form.Field>
              <span style={{ color: 'black' }}>Delivery Date</span>
              <input
                type="date"
                name="deliveryDate"
                ref={register}
                placeholder="Delivery Date"
              />
              <br />
              {errors.deliveryDate && (
                <p style={{ color: 'red' }}>{errors.deliveryDate.message}</p>
              )}
            </Form.Field>
            {/* <Form.Field>
              <span style={{ color: 'black' }}>Site</span>
              <select name="siteId" ref={register}>
                <option value="">--Select Site--</option>
                {sites.map((site) => (
                  <option
                    key={site.id}
                    value={`${site.id},${site.name}`}
                    selected={
                      assetData.siteName &&
                      (site.name === assetData.siteName.split(',')[1] ||
                        site.name === assetData.siteName)
                    }
                  >
                    {site.label || site.name}
                  </option>
                ))}
              </select>
              <small style={{ color: 'red' }}>**</small>
              <br />
              {errors.siteId && (
                <p style={{ color: 'red' }}>{errors.siteId.message}</p>
              )}
            </Form.Field> */}
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button negative form="deviceAddForm" type="submit" value="edit">
            <IntelMsg id="Submit" />
          </Button>
          <Button
            className={styles.positiveStatus}
            onClick={() => setOpenEditModal(false)}
          >
            <IntelMsg id="Cancel" />
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  )
}

EditModal.propTypes = {
  open: Proptypes.bool.isRequired,
  setOpenEditModal: Proptypes.func.isRequired,
  prop: Proptypes.func.isRequired,
  assetData: Proptypes.object,
}

export default EditModal
